/**
 * @param {object} state
 * @param {object} option
 */
const addOption = (state, option) => {
  const index = state.options.length

  state.options.splice(index, 1, option)
}

/**
 * @param {object}   state
 * @param {object[]} options
 */
const setOptions = (state, options) => {
  state.options = options
}

/**
 * @param {object} state
 * @param {string} latestDeliveryAssigned
 */
const setLatestDeliveryAssigned = (state, latestDeliveryAssigned) => {
  state.latestDeliveryAssigned = latestDeliveryAssigned
}

/**
 * @param {object} state
 * @param {object} option
 */
const updateOption = (state, option) => {
  const index = state.options.findIndex(b => b.id === option.id)

  const updatedOption = {
    ...state.options[index],
    ...option
  }

  state.options.splice(index, 1, updatedOption)
}

/**
 * @param {object}  state
 * @param {boolean} option
 */
const setOptionUploadStatus = (state, option) => {
  state.isUploadingOption = option
}

/**
 * @param {object} state
 * @param {number} optionId
 */
const deleteOption = (state, optionId) => {
  const index = state.options.findIndex(option => option.id === optionId)

  state.options.splice(index, 1)
}

/**
 * @param {object} state
 * @param {object} optionMetaFilters
 */
const setOptionMetaFilters = (state, optionMetaFilters) => {
  state.optionMetaFilters = optionMetaFilters
}

/**
 * @param {object} state
 */
const resetOptionsPaginated = state => {
  state.optionsPaginatedPage = 1
  state.options = []
  state.hasReachedOptionsPaginatedEnd = false
}

/**
 * @param {object} state
 */
const incrementOptionsPaginatedPage = state => {
  state.optionsPaginatedPage++
}

/**
 * @param {object}  state
 * @param {boolean} hasReachedOptionsPaginatedEnd
 */
const setHasReachedOptionsPaginatedEnd = (
  state,
  hasReachedOptionsPaginatedEnd
) => {
  state.hasReachedOptionsPaginatedEnd = hasReachedOptionsPaginatedEnd
}

/**
 * @type {object}
 */
const mutations = {
  addOption,
  deleteOption,
  setOptions,
  updateOption,
  setOptionUploadStatus,
  setOptionMetaFilters,
  setLatestDeliveryAssigned,
  incrementOptionsPaginatedPage,
  resetOptionsPaginated,
  setHasReachedOptionsPaginatedEnd
}

export default mutations
